import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import { customStyle } from 'helper';
import * as actions from '../action';
import * as c from '../constant';

function BuvModal({
  createBuv,
  getBuvList,
  history,
  getSingleBuv,
  getLandClassificationsList,
  landClassificationList,
  getSubClassificationsList,
  subClassificationList,
  getLocationList,
  locationList,
  getOrdinanceRevisionList,
  ordinanceRevisionList,
  getStreetList,
  streetList,
  type,
  updateBuv,
  updateList,
  buvId,
  getDistrictList,
  districtList,
  ordinanceRevisionId,
}) {
  const [formData, setFormData] = useState({
    // street_code: '',
    street_from_id: '',
    street_to_id: '',
    land_sub_classification_id: '',
    ordinance_revision_id: ordinanceRevisionId,
    rptax_location_id: '',
    land_classification_id: '',
    rptax_district_id: '',
  });
  const validateForm = useFormValidator(formData, {
    // street_code: 'required',
    // street_from_id: 'required',
    // street_to_id: 'required',
    rptax_location_id: 'required',
    rptax_district_id: 'required',
    land_classification_id: 'required',
    land_sub_classification_id: 'required',
    ordinance_revision_id: 'required',
  });

  useEffect(() => {
    getLandClassificationsList();
    getOrdinanceRevisionList();
    getDistrictList();
  }, []);

  useEffect(() => {
    getStreetList({ rptax_location_id: _.get(formData, 'rptax_location_id') });
  }, [_.get(formData, 'rptax_location_id')]);

  const setModal = useContext(ModalContext);

  // const onChange = (e) => {
  //   setFormData({
  //     ...formData,
  //     [e.target.name]: e.target.value,
  //   });
  // };

  const handleSelected = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
    if (key === 'land_classification_id') {
      getSubClassificationsList(
        e.value,
        {
          ordinance_revision_id: formData.ordinance_revision_id,
        },
        ({ data }) => {
          if (+formData.land_classification_id !== +e.value) {
            setFormData({
              ...formData,
              land_sub_classification_id: data[0].id,
              [key]: e.value,
            });
          }
        }
      );
    }
    if (key === 'ordinance_revision_id') {
      getSubClassificationsList(
        formData.land_classification_id,
        {
          ordinance_revision_id: e.value,
        },
        ({ data }) => {
          if (+formData.ordinance_revision_id !== +e.value) {
            setFormData({
              ...formData,
              land_sub_classification_id: data[0].id,
              [key]: e.value,
            });
          }
        }
      );
    }
    if (key === 'rptax_district_id') {
      getLocationList({ rptax_district_id: e.value });
    }
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (type === 'NEW') {
      createBuv(formData, ({ data }) => {
        setModal({ isOpen: false });
        getBuvList({
          ordinance_revision_id: ordinanceRevisionId,
          isPaginate: 1,
        });
        history.push(`/rpt/land/land-settings/buv/${_.get(data, 'id')}`);
        getSingleBuv(data.id);
      });
    }

    if (type === 'EDIT') {
      updateBuv(buvId, formData, ({ data }) => {
        setModal({ isOpen: false });
        getBuvList({
          ordinance_revision_id: ordinanceRevisionId,
          isPaginate: 1,
        });
        history.push(`/rpt/land/land-settings/buv/${_.get(data, 'id')}`);
        getSingleBuv(data.id);
      });
    }
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };

      getSubClassificationsList(_.get(updateList, 'land_classification_id'), {
        ordinance_revision_id: _.get(updateList, 'ordinance_revision_id'),
      });
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    if (type === 'EDIT') {
      onSetFormData();
    }
  }, []);

  const landClassificationOptions = landClassificationList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const subClassificationOptions = subClassificationList.map((x) => ({
    label: `${
      _.get(x, 'attributes.description')
        ? _.get(x, 'attributes.description')
        : ''
    } - ${_.get(x, 'attributes.unit_value', '')}`,
    value: x.id,
    id: x.id,
  }));

  const locationOptions = locationList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const ordinanceRevisionsOptions = ordinanceRevisionList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));
  const streetOptions = streetList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const districtOptions = districtList.map((x) => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="form-label">
              District &nbsp; {validateForm.renderMessage('rptax_district_id')}
            </label>
            <div>
              <Select
                options={districtOptions}
                styles={customStyle}
                placeholder="Select District"
                value={
                  districtOptions.filter(
                    (item) =>
                      +_.get(formData, 'rptax_district_id') ===
                      +_.get(item, 'id')
                  ) || ''
                }
                onChange={handleSelected('rptax_district_id')}
              />
            </div>
          </div>
          <div className="col-12 form-group">
            <label className="form-label">
              Location &nbsp; {validateForm.renderMessage('rptax_location_id')}
            </label>
            <div>
              <Select
                options={locationOptions}
                styles={customStyle}
                placeholder="Select Location"
                value={
                  locationOptions.filter(
                    (item) =>
                      +_.get(formData, 'rptax_location_id') ===
                      +_.get(item, 'id')
                  ) || ''
                }
                onChange={handleSelected('rptax_location_id')}
              />
            </div>
          </div>
          {/* <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Street Code {validateForm.renderMessage('street_code')}
            </label>
            <input
              className="form-control"
              type="number"
              name="street_code"
              onChange={onChange}
              value={_.get(formData, 'street_code')}
            />
          </div> */}
          <div className="col-12 form-group">
            <label className="form-label">Street From</label>
            <div>
              <Select
                options={streetOptions}
                styles={customStyle}
                placeholder="Select Street"
                value={
                  streetOptions.filter(
                    (item) =>
                      +_.get(formData, 'street_from_id') === +_.get(item, 'id')
                  ) || ''
                }
                onChange={handleSelected('street_from_id')}
              />
            </div>
          </div>
          <div className="col-12 form-group">
            <label className="form-label">Street To</label>
            <div>
              <Select
                options={streetOptions}
                styles={customStyle}
                placeholder="Select Street"
                value={
                  streetOptions.filter(
                    (item) =>
                      +_.get(formData, 'street_to_id') === +_.get(item, 'id')
                  ) || ''
                }
                onChange={handleSelected('street_to_id')}
              />
            </div>
          </div>
          <div className="col-12 form-group">
            <label className="form-label">
              Land Classification &nbsp;{' '}
              {validateForm.renderMessage('land_classification_id')}
            </label>
            <div>
              <Select
                options={landClassificationOptions}
                styles={customStyle}
                placeholder="Select Land Classification"
                value={
                  landClassificationOptions.filter(
                    (item) =>
                      +_.get(formData, 'land_classification_id') ===
                      +_.get(item, 'id')
                  ) || ''
                }
                onChange={handleSelected('land_classification_id')}
              />
            </div>
          </div>
          <div className="col-12 form-group">
            <label className="form-label">
              Sub-classification: &nbsp;{' '}
              {validateForm.renderMessage('land_sub_classification_id')}
            </label>
            <div>
              <Select
                options={subClassificationOptions}
                styles={customStyle}
                placeholder="Select Sub-classification"
                value={
                  subClassificationOptions.filter(
                    (item) =>
                      +_.get(formData, 'land_sub_classification_id') ===
                      +_.get(item, 'id')
                  ) || ''
                }
                onChange={handleSelected('land_sub_classification_id')}
              />
            </div>
          </div>
          <div className="col-12 form-group">
            <label className="form-label">Ordinance Revision</label>
            <div>
              <Select
                options={ordinanceRevisionsOptions}
                styles={customStyle}
                placeholder="Select Ordinance Revisions"
                value={
                  ordinanceRevisionsOptions.filter(
                    (item) =>
                      +_.get(formData, 'ordinance_revision_id') ===
                      +_.get(item, 'id')
                  ) || ''
                }
                isDisabled
                onChange={handleSelected('ordinance_revision_id')}
              />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={!validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary mr-3"
          >
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

BuvModal.defaultProps = {
  type: '',
  updateList: {},
  buvId: '',
};

BuvModal.propTypes = {
  type: PropTypes.string,
  buvId: PropTypes.string,
  updateList: PropTypes.instanceOf(Object),
  getBuvList: PropTypes.instanceOf(Function).isRequired,
  createBuv: PropTypes.instanceOf(Function).isRequired,
  updateBuv: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleBuv: PropTypes.instanceOf(Function).isRequired,
  getSubClassificationsList: PropTypes.instanceOf(Function).isRequired,
  subClassificationList: PropTypes.instanceOf(Array).isRequired,
  getLandClassificationsList: PropTypes.instanceOf(Function).isRequired,
  landClassificationList: PropTypes.instanceOf(Array).isRequired,
  getOrdinanceRevisionList: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionList: PropTypes.instanceOf(Array).isRequired,
  getStreetList: PropTypes.instanceOf(Function).isRequired,
  streetList: PropTypes.instanceOf(Array).isRequired,
  getLocationList: PropTypes.instanceOf(Function).isRequired,
  locationList: PropTypes.instanceOf(Array).isRequired,
  getDistrictList: PropTypes.instanceOf(Function).isRequired,
  districtList: PropTypes.instanceOf(Array).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  landClassificationList:
    _.get(api, `${c.GET_LAND_CLASSIFICATIONS}.list`) || [],
  subClassificationList:
    _.get(api, `${c.GET_SUB_CLASSICATION_LIST}.list`) || [],
  ordinanceRevisionList: _.get(api, `${c.GET_ORDINANCE_REVISION}.list`) || [],
  streetList: _.get(api, `${c.GET_STREETS}.list`) || [],
  locationList: _.get(api, `${c.GET_LOCATION_LIST}.list`) || [],
  districtList: _.get(api, `${c.GET_DISTRICT_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(BuvModal);
